import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IModalBase } from '../../interfaces/commonInterfaces'
import moment from 'moment'

export interface OrderState {
  orderList?: unknown
  orderOptionList?: unknown
  orderDetail?: unknown
  reloadOrderList?: string | null
  modalOrder?: IModalBase
}

const initialState: OrderState = {
  orderList: {},
  orderOptionList: {},
  orderDetail: {},
  reloadOrderList: null,
  modalOrder: {
    visible: false,
    record: {},
  },
}

export const orderDucks = createSlice({
  name: 'order',
  initialState,
  reducers: {
    getListOrder: (state, action: PayloadAction<string | undefined>) => {
      state.orderList = { loading: true, queryStr: action.payload }
    },
    getListOrderSuccess: (state, action: PayloadAction<unknown>) => {
      state.orderList = { loading: false, ...(action.payload as object) }
    },
    getListOrderFail: (state, action: PayloadAction<unknown>) => {
      state.orderList = { loading: false, ...(action.payload as object) }
    },

    getListOptionOrder: (state, action: PayloadAction<string | undefined>) => {
      state.orderOptionList = { loading: true, queryStr: action.payload }
    },
    getListOptionOrderSuccess: (state, action: PayloadAction<unknown>) => {
      state.orderOptionList = { loading: false, ...(action.payload as object) }
    },
    getListOptionOrderFail: (state, action: PayloadAction<unknown>) => {
      state.orderOptionList = { loading: false, ...(action.payload as object) }
    },

    getDetailOrder: (state, action: PayloadAction<string | number>) => {
      state.orderDetail = { loading: true, id: action.payload }
    },
    getDetailOrderSuccess: (state, action: PayloadAction<unknown>) => {
      state.orderDetail = { loading: false, ...(action.payload as object) }
    },
    getDetailOrderFail: (state, action: PayloadAction<unknown>) => {
      state.orderDetail = { loading: false, ...(action.payload as object) }
    },

    setReloadOrderList: (state) => {
      state.reloadOrderList = String(moment())
    },
    setModalOrder: (state, action: PayloadAction<IModalBase>) => {
      state.modalOrder = action.payload
    },
  },
})

export const {
  getListOrder,
  getListOrderSuccess,
  getListOrderFail,
  getListOptionOrder,
  getListOptionOrderSuccess,
  getListOptionOrderFail,
  getDetailOrder,
  getDetailOrderSuccess,
  getDetailOrderFail,
  setReloadOrderList,
  setModalOrder,
} = orderDucks.actions

export default orderDucks.reducer
